import { z } from "zod";
import { Roles } from "@fysaro/domain";
import { LANGUAGE_CODES } from "@fysaro/shared";

export const loginSchema = z
  .object({
    email: z.string().email(),
    password: z.string().min(6),
  })
  .strict();

export const registerSchema = z
  .object({
    role: z.enum(Object.values(Roles) as [string, ...string[]]),
    email: z.string().email(),
    password: z.string().min(6),
    name: z.string().min(2),
    // 🌟 NUEVO: El objeto de detección silenciosa del frontend
    detection: z
      .object({
        locale: z.string().optional(),
        theme: z.string().optional(),
        timeZone: z.string().optional(),
      })
      .optional(),
    acceptTerms: z.literal(true, {
      message: "Debes aceptar los términos y la privacidad.",
    }),
  })
  .strict();

export const updateAuthSchema = z
  .object({
    name: z.string().optional(),
    phone: z.string().optional(),
    language: z.enum(LANGUAGE_CODES).optional(),
    imageUrl: z
      .string()
      .optional()
      .transform((v) => (v === "" ? undefined : v))
      .pipe(z.string().url().optional()),
  })
  .strict();

export const setPasswordSchema = z.object({
  audience: z.string(),
  password: z.string().min(6, "La contraseña debe tener al menos 6 caracteres"),
});

export const assignRoleSchema = z
  .object({
    userId: z.string().uuid(),
    role: z.enum(Object.values(Roles) as [string, ...string[]]),
  })
  .strict();
